<template>
    <div class="app-inner">
        <!-- <div class="searchTitleDiv">
            <div class="stateDiv">
                <p class="searchText">状态</p>
                <el-select v-model="searchFrom.status" placeholder="请选择" class="inputDiv" clearable>
                    <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
            <el-button class="searchBtn" type="warning">导出</el-button>
        </div> -->
        <!--      列表-->
        <div class="table">
            <div class="searchList">
                <TableList :data="tableData" :columnDefs="tableColumns" :total="totalCount"
                    @pageChange="handleCurrentChange">
                    <template #action="{ row, index }" class="tableButton">
                        <!-- <el-button class="tableBtn" @click="viewOrHandle(row, 'edit')" type="text" size="small">编辑
                        </el-button> -->
                        <el-button class="tableBtn" @click="viewOrHandle(row, 'view')" type="text" size="small">查看详情
            </el-button>
                        <!-- <el-button class="tableBtn" @click="deleteFun(row)" type="text" size="small">删除</el-button> -->
                    </template>
                </TableList>
            </div>
        </div>
        <!--    新增/编辑弹框-->
        <div class="dialogDiv">
            <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeData" center>
                <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px"
                    disabled>
                    <el-row>
                        <el-form-item label="开始时间" prop="begin" class="formItem">
                            <el-date-picker v-model="addForm.begin" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" style="width:100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="结束时间" prop="end" class="formItem">
                            <el-date-picker v-model="addForm.end" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" style="width:100%">
                            </el-date-picker>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="加班时长" prop="dayCount" class="formItem">
                            <el-input-number v-model="addForm.dayCount"  :min="0.5" :max="100" placeholder="大于等于0.5" style="width:90%;margin-right:5px" :controls="false"></el-input-number>天
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="申请事由" prop="applyReason" class="formItem">
                            <el-input type="textarea" v-model="addForm.applyReason" clearable placeholder="请输入"
                                maxlength="500" show-word-limit></el-input>
                        </el-form-item>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeData">取 消</el-button>
                    <el-button type="primary" @click="addEventForm()" v-if="eventControl !== '查看详情'">保 存</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { compOperatorLog } from '@/api/comprehensive'
// import { validPassword } from '@/assets/scripts/validate'
import { Message } from 'element-ui'
import TableList from '@/components/TableList'
export default {
    name: 'accountPage',
    components: {
        TableList,
    },
    data() {
        return {
            loading: false,
            searchFrom: {
                status: '', // 状态
            },
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            dialogFormVisible: false,
            eventControl: '',
            edit: false,
            passwordForm: {},
            addForm: {
                begin: '', // 使用开始时间
                end: '', // 使用结束时间
                dayCount: null, // 加班时长
                applyReason: '', // 申请原因
            },
            rules: {
                title: [{ required: true, message: '请填写', trigger: 'blur' }],
                content: [{ required: true, message: '请填写', trigger: 'blur' }],
            },
            tableData: [],
            statusOptions: [
                {
                    label: '待审核',
                    value: 0
                },
                {
                    label: '已通过',
                    value: 1
                },
                {
                    label: '已拒绝',
                    value: 2
                },
            ],
            tableColumns: [
                 {
                    prop: 'userName',
                    label: '用户名（账号）'
                },
                {
                    prop: 'chineseName',
                    label: '中文名'
                },
                {
                    prop: 'content',
                    label: '操作'
                },
                {
                    prop: 'createTime',
                    label: '操作时间'
                },
            ]
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        handleFile(imgs) {
            let arrFile = imgs.map(v => v.name).join(',')
            this.addForm.fileUrlList = arrFile
        },
        getData() {
            this.currentPage = 1
            this.queryList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.queryList()
        },
        async queryList() {
            let res = await compOperatorLog('query', {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            })
            if (res.code === 0) {
                this.tableData = res.result.records
                this.totalCount = res.result.total
            }
        },
        addFormData() {
            this.edit = false
            this.dialogFormVisible = true
            this.eventControl = '加班申请'
        },
        async viewOrHandle(row, type) {
            console.log(row);
            this.edit = true
            this.eventControl = type === 'edit' ? '编辑公告' : '查看详情'
            this.newOldFormContrast(row)
            this.dialogFormVisible = true
        },
        newOldFormContrast(newForm) {
            Object.keys(this.addForm).forEach(key => {
                this.addForm[key] = newForm[key]
            })
            this.addForm.id = newForm.id
            console.log(this.addForm, 'this.addForm');
        },
        closeData() {
            this.dialogFormVisible = false
            this.$refs['addForm'].resetFields()
            this.addForm = this.$options.data.call(this).addForm
        },
        addEventForm() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    if (this.edit) {
                        let res = await compOperatorLog('update', this.addForm)
                        if (res.code === 0) {
                            Message.success('编辑成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.warning({ message: res.message })
                        }
                    } else {
                        let res = await compOperatorLog('add', this.addForm)
                        if (res.code === 0) {
                            Message.success('新增成功！')
                            this.closeData()
                            await this.getData()
                        } else {
                            Message.error(res.message)
                        }
                    }
                }
            })
        },
        // 删除用户
        deleteFun(row) {
            this.$confirm('此操作将删除当前数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let params = {
                    'id': row.id
                }
                let res = await compOperatorLog('delete', params)
                if (res.code === 0) {
                    Message.success('删除成功！')
                }
                await this.getData()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
}

.searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;
    /*display: flex;*/
    /*justify-content: space-around;*/

    .stateDiv {
        margin-top: 0.14rem;
        margin-left: .3rem;
        float: left;
    }

    .searchText {
        margin-top: 0.05rem;
        margin-right: 0.13rem;
        font-size: 0.2rem;
        color: #111111;
        float: left;
    }

    .inputDiv {
        width: 2.2rem;
        float: left;
    }

    .searchBtn {
        /*width: 1.20rem;*/
        /*height: 0.36rem;*/
        /*border-radius: 0.06rem;*/
        /*font-size: 0.18rem;*/
        margin-top: 0.14rem;
        margin-left: .3rem;
        /*padding-top: 0.1rem;*/
    }
}

.table {
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;

    .searchList {}

    .paginationBody {
        margin-top: .1rem;
    }
}

.formItem {
    // width: 3.2rem;
}

/deep/ .el-dialog {
    width: 30% !important;
}
</style>
